exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".exceededGuests[data-v-375f7594]{color:#f4455c}.tooltip[data-v-375f7594]{position:relative;display:inline-block;border-bottom:1px dotted #000}.tooltip .tooltiptext[data-v-375f7594]{visibility:hidden;width:220px;background-color:#000;color:#fff;text-align:center;padding:5px 0;border-radius:6px;position:absolute;z-index:1}.tooltip:hover .tooltiptext[data-v-375f7594]{visibility:visible}input[type=checkbox][disabled=disabled]+label[data-v-375f7594]{opacity:.4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-375f7594","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/tabs/Guests.vue
// module id = 78
// module chunks = 0